import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import api from '../services/api';

const STATUS = {
  aguardando:        { label:'Aguardando',        color:'#d8bd69', bg:'rgba(216,189,105,.15)' },
  em_analise:        { label:'Em análise',         color:'#2563eb', bg:'rgba(37,99,235,.1)'   },
  aprovado:          { label:'Aprovado',           color:'#1e7d47', bg:'rgba(30,125,71,.12)'  },
  recusado:          { label:'Recusado',           color:'#be2e2e', bg:'rgba(190,46,46,.1)'   },
  ajuste_solicitado: { label:'Ajuste solicitado',  color:'#c85718', bg:'rgba(200,87,24,.12)'  },
};

export default function MinhasSolicitacoes() {
  const [items, setItems]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/solicitacoes/minhas').then(({ data }) => setItems(data)).finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Navbar />
      <div style={{ background:'var(--cream)', minHeight:'calc(100vh - 112px)', padding:'56px 0' }}>
        <div className="container">
          <div className="page-header" style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-end' }}>
            <div>
              <div className="eyebrow">Área Premium</div>
              <h1 className="section-title">Minhas solicitações</h1>
              <div className="gold-rule" />
            </div>
            <Link to="/vender" className="btn btn-primary btn-sm">+ Novo anúncio</Link>
          </div>

          {loading ? <p style={{ color:'var(--ink-muted)' }}>Carregando…</p>
          : items.length === 0 ? (
            <div className="card" style={{ padding:60, textAlign:'center' }}>
              <div style={{ fontSize:44, marginBottom:16 }}>📋</div>
              <p style={{ color:'var(--ink-muted)', marginBottom:22, lineHeight:1.6 }}>Você ainda não enviou nenhum veículo para análise.</p>
              <Link to="/vender" className="btn btn-primary">Anunciar meu veículo</Link>
            </div>
          ) : (
            <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
              {items.map(s => {
                const st = STATUS[s.status] || STATUS.aguardando;
                return (
                  <div key={s.id} className="card" style={{ padding:'22px 28px', display:'flex', justifyContent:'space-between', alignItems:'center', gap:20 }}>
                    <div>
                      <div style={{ fontFamily:"'Playfair Display',serif", fontSize:18, fontWeight:600, marginBottom:4 }}>
                        {s.marca?.replace(/"/g,'')} {s.modelo?.replace(/"/g,'')} {s.ano?.replace(/"/g,'')}
                      </div>
                      <div style={{ fontSize:12, color:'var(--ink-muted)' }}>
                        Enviado em {new Date(s.created_at).toLocaleDateString('pt-BR')}
                      </div>
                    </div>
                    <div style={{ background:st.bg, color:st.color, border:`1px solid ${st.color}33`, padding:'5px 14px', borderRadius:'var(--r-sm)', fontSize:10, fontWeight:900, letterSpacing:1.2, textTransform:'uppercase', flexShrink:0 }}>
                      {st.label}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
